import {ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
	dialogRef = inject<DialogRef<boolean>>(DialogRef);

	caption = input<string>('');
	action = input<string>('Bevestigen');
	secondaryAction = input<string>('Annuleren');
	singleAction = input<boolean>(false);
}
